import React from 'react';
import { fmtUSD, fmtPct } from '../lib/math';

export default function DrillDownPanel({ drill, onClose }) {
  const { slot, r } = drill;
  const b = r.breakdown;
  return (
    <div
      className="bg-white rounded-lg border border-[#2FA163]/30 shadow-sm p-6 mb-8 bg-[#2FA163]/5"
      data-testid="bta-drilldown-panel"
    >
      <div className="flex justify-between items-start mb-4">
        <div>
          <div className="text-xs uppercase tracking-wider text-[#286C4E] font-semibold mb-1">
            Drill-down — full waterfall
          </div>
          <h3 className="text-xl font-bold text-[#092825]">
            {slot.name}{slot.on_team ? ' + ' + slot.team_name : ''}
          </h3>
        </div>
        <button
          type="button"
          onClick={onClose}
          data-testid="bta-drilldown-close-btn"
          className="text-slate-400 hover:text-slate-600 text-xl leading-none"
        >
          ×
        </button>
      </div>
      <div className="grid grid-cols-2 gap-x-8 gap-y-2 text-sm">
        <div className="flex justify-between border-b border-slate-200 py-1">
          <span className="text-slate-600">Total GCI</span>
          <span className="font-semibold tabular-nums">{fmtUSD(r.totalGCI)}</span>
        </div>
        <div className="flex justify-between border-b border-slate-200 py-1">
          <span className="text-slate-600">Referral fees out</span>
          <span className="tabular-nums text-red-600">−{fmtUSD(b.totalReferralOut)}</span>
        </div>
        <div className="flex justify-between border-b border-slate-200 py-1">
          <span className="text-slate-600">Concessions to clients</span>
          <span className="tabular-nums text-red-600">−{fmtUSD(b.totalConcessions)}</span>
        </div>
        {slot.is_kw && (
          <div className="flex justify-between border-b border-slate-200 py-1">
            <span className="text-slate-600">KW royalty (6%, capped)</span>
            <span className="tabular-nums text-red-600">−{fmtUSD(b.totalRoyalty)}</span>
          </div>
        )}
        <div className="flex justify-between border-b border-slate-200 py-1">
          <span className="text-slate-600">Brokerage split / post-cap fees</span>
          <span className="tabular-nums text-red-600">−{fmtUSD(b.totalBrokerageTake)}</span>
        </div>
        {slot.on_team && (
          <div className="flex justify-between border-b border-slate-200 py-1">
            <span className="text-slate-600">Team split ({slot.team_split_pct}%)</span>
            <span className="tabular-nums text-red-600">−{fmtUSD(b.totalTeamTake)}</span>
          </div>
        )}
        <div className="flex justify-between border-b border-slate-200 py-1">
          <span className="text-slate-600">TC / flat per-deal fees</span>
          <span className="tabular-nums text-red-600">−{fmtUSD(b.totalTcFees)}</span>
        </div>
        <div className="flex justify-between border-b border-slate-200 py-1">
          <span className="text-slate-600">Monthly fees × 12</span>
          <span className="tabular-nums text-red-600">−{fmtUSD(b.monthlyFees)}</span>
        </div>
        <div className="flex justify-between border-b border-slate-200 py-1">
          <span className="text-slate-600">Annual E&O</span>
          <span className="tabular-nums text-red-600">−{fmtUSD(b.annualEo)}</span>
        </div>
        {slot.on_team && b.teamMonthlyFees > 0 && (
          <div className="flex justify-between border-b border-slate-200 py-1">
            <span className="text-slate-600">Team monthly × 12</span>
            <span className="tabular-nums text-red-600">−{fmtUSD(b.teamMonthlyFees)}</span>
          </div>
        )}
        <div className="flex justify-between col-span-2 border-t-2 border-slate-400 pt-2 mt-2">
          <span className="font-bold text-[#092825]">Annual net take-home</span>
          <span className="font-bold text-xl tabular-nums text-[#2FA163]">
            {fmtUSD(r.annualNet)}
          </span>
        </div>
        <div className="flex justify-between col-span-2">
          <span className="text-slate-600">Effective split</span>
          <span className="font-semibold tabular-nums">{fmtPct(r.effectiveSplit)}</span>
        </div>
      </div>
    </div>
  );
}
